export const JournalStates = {
    Active: 0,

    Completed: 1,

    Hidden: 2,

    /// <summary>
    /// for template notes
    /// </summary>
    Approved: 100,

    Deleted: 999,

    /// <summary>
    /// marker for code: all means no filter
    /// </summary>
    All: 1000,
};
